import { RequestManager } from '@jaseeey/request-manager';
import { useMessagePack } from 'composables/message-pack';
import { usePiniaManager } from 'composables/pinia-manager';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const PREFERENCES_TTL_MINS = 5;

export const useUserSearchPreferencesStore = defineStore('user-search-preferences', () => {

    const { decodeResponse } = useMessagePack();
    const piniaManager = usePiniaManager();

    const preferences = ref({
        location: null,
        remuneration: {
            min: null,
            max: null,
            cycle: null
        }
    });
    const isPreferencesDirty = ref(false);
    const isPreferencesLoading = ref(false);
    const preferencesLoadedAt = ref(null);

    const isPreferencesLoaded = computed(() => !!preferencesLoadedAt.value);

    function invalidatePreferences() {
        isPreferencesDirty.value = true;
    }

    async function loadPreferences() {
        if (!piniaManager.isInvalidated(isPreferencesDirty, preferencesLoadedAt, PREFERENCES_TTL_MINS)) {
            return preferences.value;
        }
        isPreferencesLoading.value = true;
        return RequestManager.call(this.$api, 'get', '/user/preferences', {}, {
            responseType: 'arraybuffer',
            headers: {
                'Accept': 'application/json,application/msgpack'
            }
        }, res => {
            preferences.value = decodeResponse(res.data);
            preferencesLoadedAt.value = Date.now();
            isPreferencesLoading.value = false;
            return preferences.value;
        }, err => {
            isPreferencesLoading.value = false;
            throw err;
        });
    }

    async function savePreferences(updatedPreferences) {
        preferences.value = (await this.$api.put('/user/search-preferences', updatedPreferences)).data;
        isPreferencesDirty.value = false;
        preferencesLoadedAt.value = Date.now();
    }

    return {
        // State
        preferences,
        isPreferencesLoading,
        preferencesLoadedAt,
        // Getters
        isPreferencesLoaded,
        // Actions
        invalidatePreferences,
        loadPreferences,
        savePreferences
    };
});
